module.exports = __webpack_public_path__ + "img/clicked.c46cad2e.svg";